import { TextareaAutosize, TextareaAutosizeProps } from '@material-ui/core';
import clsx from 'clsx';
import { useSharedStyles } from '../../../common/sharedStyles';

export default (props: {
    className?: string;
} & TextareaAutosizeProps) => {
    const { className, ...rest } = props;
    const sharedClasses = useSharedStyles();
    return <TextareaAutosize
        {...rest}
        className={clsx(sharedClasses.input, className)}
    />
}
